import type { TView } from '@alfa-bank/site-text-v2/src/models';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

export const configDesktop = {
    titleImg: {
        width: 64,
        height: 64,
    },
    titleIconSize: 20,
    titleView: 'small' as TView,
    showCheckMark: true,
    showPseudoCheckbox: false,
    titleOffset: {
        marginBottom: 24,
    } as IStyler,
    backgroundOffset: {
        padding: 24,
    } as IStyler,
    isMultipleSelect: true,
};

export const configMobile = {
    titleImg: {
        width: 48,
        height: 48,
    },
    titleIconSize: 16,
    titleView: 'xsmall' as TView,
    showCheckMark: false,
    showPseudoCheckbox: true,
    titleOffset: {
        marginBottom: 16,
    } as IStyler,
    backgroundOffset: { padding: 16 } as IStyler,
    isMultipleSelect: false,
};
